import { NgFor, NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormArray, FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbAlert } from '@ng-bootstrap/ng-bootstrap';
import { LabelModule } from '@progress/kendo-angular-label';
import { ValidationErrorKeysPipe, validationMessages } from '../../pipes/validation-error-keys.pipe';

@Component({
  selector: 'shared-ui-listview',
  templateUrl: './shared-ui-listview.component.html',
  styleUrl: './shared-ui-listview.component.scss',
  standalone: true,
  imports: [NgIf, LabelModule,FormsModule, ReactiveFormsModule, NgFor, NgbAlert, ValidationErrorKeysPipe]
})
export class SharedUiListviewComponent {
  @Input() label = '';
  @Input() control?: FormControl
  @Input() options: any[] | null = null;
  @Input() valueName: string = '';
  @Input() displayName: string = ''
  @Input() placeholder?: string
  @Input() messages = validationMessages
  @Input() isChecked: boolean = false;
  @Input() checkCondition: string = '';
}


